import { Component, OnInit } from '@angular/core';
import { IconComponent } from '../../../core/labels/icon.component';
import { TagComponent } from '../../../core/labels/tag.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { BaseComponent } from '../../../base/base.component';
import { getClaimKey } from '../../../../functions/get-claim-key';
import {
  LoadingState,
  LoadingPanelComponent,
} from '../../../core/panels/loading-panel.component';
import { ClaimAdaTamsSummary } from '../../../../models/api/view/claim/summary/claimadatamssummary';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';

@Component({
  selector: 'app-ad-claim-card',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    IconComponent,
    TagComponent,
    LoadingPanelComponent,
  ],
  template: `
    <app-loading-panel
      [state]="loadingState"
      [loadingHeight]="300"
      loadingStyle="Box"
      [error]="error"
    >
      <ng-template #loaded>
        <div class="tw-w-full">
          <div
            class="tw-flex tw-flex-col md:tw-flex-row tw-gap-0 md:tw-gap-8 tw-w-full"
          >
            <app-detail-panel
              [dataSource]="claim"
              [showEmpty]="false"
              class="tw-w-full "
            >
              <app-detail-item name="status" label="Status">
                @if (
                  claim.substatus === 'Pending Business Approval' ||
                  claim.substatus === 'Under review' ||
                  claim.substatus === 'Pending business response'
                ) {
                  <ng-template #value>
                    <app-tag type="Warn">Open</app-tag>
                  </ng-template>
                } @else if (claim.status === 'Closed') {
                  <ng-template #value>
                    <app-tag type="Error">Closed</app-tag>
                  </ng-template>
                } @else if (claim.status === 'Open') {
                  <ng-template #value>
                    <app-tag type="Success">Open</app-tag>
                  </ng-template>
                }
              </app-detail-item>
              <app-detail-item label="Substatus" name="substatus">
                @if (
                  claim.substatus === 'Pending Business Approval' ||
                  claim.substatus === 'Under review' ||
                  claim.substatus === 'Pending business response'
                ) {
                  <ng-template #value>
                    <app-tag type="Warn">{{ claim.substatus }}</app-tag>
                  </ng-template>
                } @else if (
                  claim.substatus === 'Currently Accommodated' ||
                  claim.substatus === 'Currently accommodated'
                ) {
                  <ng-template #value>
                    <app-tag type="Success">{{ claim.substatus }}</app-tag>
                  </ng-template>
                } @else {
                  <ng-template #value>
                    <app-tag type="Grey">{{ claim.substatus }}</app-tag>
                  </ng-template>
                }
              </app-detail-item>
              <app-detail-item label="Claim number" name="claimNumber" />
              <app-detail-item label="Reported by" name="reportedBy" />
              <app-detail-item
                label="At-Work injury/illness"
                name="atWorkInjury"
                format="b"
              />
              <app-detail-item
                label="Certification required"
                name="certificationRequired"
                format="b"
              />
              <app-detail-item
                label="Exhausted job protection"
                name="exhaustedJobProtection"
                format="b"
              />
              <app-detail-item
                labelCase="none"
                label="Filed leave or STD"
                name="filedLeaveSTD"
                format="b"
              />
            </app-detail-panel>
            <app-detail-panel
              [dataSource]="claim"
              [showEmpty]="false"
              class="tw-w-full "
            >
              <app-detail-item
                label="Intake date"
                name="intakeDate"
                format="d"
              />
              <app-detail-item
                label="Date reported"
                name="dateReported"
                format="d"
              />
              <app-detail-item
                label="Exhaustion date"
                name="exhaustionDate"
                format="d"
              />
              <app-detail-item
                labelCase="none"
                label="Estimated RTW"
                name="estimatedRtw"
                format="d"
              />
              <app-detail-item
                labelCase="none"
                label="Actual RTW"
                name="actualRtw"
                format="d"
              />
            </app-detail-panel>
          </div>
          <div
            class="tw-flex tw-flex-col md:tw-flex-row tw-gap-0 md:tw-gap-8 tw-w-full"
          >
            <app-detail-panel
              [dataSource]="claim"
              [showEmpty]="false"
              class="tw-w-full "
            >
              <app-detail-item label="Initial request" name="initialRequest" />
              <app-detail-item
                label="Underlying condition/impairment"
                name="underlyingCondition"
              />
            </app-detail-panel>
          </div>
          <div class="tw-flex tw-gap-2 tw-w-full tw-mt-4">
            @if (claim.onLegalHold) {
              <div
                class="tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-flex tw-items-center tw-pr-4 tw-border"
              >
                <div
                  class="tw-rounded-full tw-size-7 tw-m-2 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
                >
                  <span class="fa-stack" style="vertical-align: top;">
                    <app-icon
                      size="14px"
                      name="fa-light fa-gavel fa-stack-2x"
                      stackedSize="9px"
                      stackedName="fa-solid fa-pause fa-stack-1x"
                      stackedMarginBottom="5px"
                      stackedMarginRight="5px"
                    />
                  </span>
                </div>
                <span class="tw-font-bold">Legal Hold</span>
              </div>
            }
            @if (claim.pregnancy) {
              <div
                class="tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-flex tw-items-center tw-pr-4 tw-border"
              >
                <div
                  class="tw-rounded-full tw-size-7 tw-m-2 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
                >
                  <app-icon name="fa-solid fa-kit-medical" />
                </div>
                <span class="tw-font-bold">PWFA/Pregnancy</span>
              </div>
            }
            @if (claim.maintenance) {
              <div
                class="tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-flex tw-items-center tw-pr-4 tw-border"
              >
                <div
                  class="tw-rounded-full tw-size-7 tw-m-2 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
                >
                  <app-icon name="fa-solid fa-wrench" />
                </div>
                <span class="tw-font-bold">Maintenance</span>
              </div>
            }
          </div>
        </div>
      </ng-template>
    </app-loading-panel>
  `,
  styles: ``,
})
export class AdClaimCardComponent extends BaseComponent implements OnInit {
  claim: ClaimAdaTamsSummary;
  loadingState: LoadingState = 'Loading';
  error: any = null;

  @HandleLoadingState({
    loadingProperty: 'loadingState',
    onValue: 'Loading',
    offValue: 'Loaded',
  })
  async ngOnInit(): Promise<void> {
    this.claim = await this.api.claimSummary.adaTamsSummary(getClaimKey());
    this.claim.claimNumber = this.view.currentClaim()?.fileNumber;
  }
}
